<div class="table-container">
	<div #focus style="position: absolute"></div>
	<table
		mat-table
		class="mat-elevation-z8 full-width"
		matSort
		class="table-listado"
	>
		<ng-container matColumnDef="user">
			<th mat-header-cell *matHeaderCellDef>Usuario</th>
			<td mat-cell *matCellDef="let change"></td>
		</ng-container>

		<ng-container matColumnDef="modifiedField">
			<th mat-header-cell *matHeaderCellDef>Campo modificado</th>
			<td mat-cell *matCellDef="let change"></td>
		</ng-container>

		<ng-container matColumnDef="lastChange">
			<th mat-header-cell *matHeaderCellDef>Último cambio</th>
			<td mat-cell *matCellDef="let change"></td>
		</ng-container>

		<ng-container matColumnDef="updateDate">
			<th mat-header-cell *matHeaderCellDef>Actualización</th>
			<td mat-cell *matCellDef="let change"></td>
		</ng-container>

		<ng-container matColumnDef="acts">
			<th mat-header-cell *matHeaderCellDef>Acta</th>
			<td mat-cell *matCellDef="let change">
				<button mat-button style="color: #006ae6; text-decoration: underline">
					ver cambio
				</button>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	</table>
</div>
<mat-paginator [pageSizeOptions]="[5, 10, 15]" pageSize="5"></mat-paginator>
